import { render } from "./OrderHistory.vue?vue&type=template&id=54cd474c&scoped=true"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"

import "./OrderHistory.vue?vue&type=style&index=0&id=54cd474c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54cd474c"]])

export default __exports__